<template>

  <div class="row" ref="initiativeForm">
    <div class="col-xs-12 col-md-12 col-sm-12">
      <ValidationObserver v-slot="{ handleSubmit }" ref="formValidator">
        <div class="col-12">
          <div class="card card-wizard" id="wizardCard">
            <form-wizard shape="tab"
                         :title="formTitle"
                         :subtitle="''"
                         error-color="#FB404B"
                         color="#35495E"
                         ref="panelFormWizard">
              <tab-content title="English Content"
                           class="col-12"
                           icon="nc-icon nc-album-2"
                           :before-change="() => validateStep('englishStep')">
                <english-step :formData="formData ? formData['en'] : defaultFormData['en']"
                              :editMode="editMode"
                              ref="englishStep"
                              :builderData="builderData"
                              @on-validated="onStepValidated" @submit-step="submitStep"></english-step>
              </tab-content>
              <tab-content v-for="(lang, index) in languageList" :key="index" :title="lang.label+' Content'"
                           class="col-12"
                           icon="nc-icon nc-album-2"
                           :before-change="() => validateStep(lang.value)">
                <other-languages-step
                  :formData="formData ? formData[lang.value] : defaultFormData[lang.value]"
                  :editMode="editMode"
                  :builderData="builderData"
                  :isSubmit="languageList.length - 1 === index"
                  :lang="lang" :ref="lang.value" @on-validated="onStepValidated"
                  @submit-step="submitStep"></other-languages-step>
              </tab-content>

              <button slot="prev" class="btn btn-default btn-fill btn-wd btn-back">Back</button>
              <button slot="next" class="btn btn-default btn-fill btn-wd btn-next">Next</button>
              <button @submit="validateStep" slot="finish" class="btn btn-success btn-fill btn-wd" :disabled="entityNotFoundError || submitting">Finish</button>
            </form-wizard>
          </div>
        </div>
      </ValidationObserver>

    </div>

  </div>
</template>
<script>
import { extend } from "vee-validate";
import { required, email } from "vee-validate/dist/rules";

import {FormWizard, TabContent} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import EnglishStep from "./Wizard/EnglishStep";
import OtherLanguagesStep from "./Wizard/OtherLanguagesStep";
import {mapGetters} from "vuex";



extend("required", {
  message: "{_field_} is required"
});

export default {

  components: {
    FormWizard,
    TabContent,
    OtherLanguagesStep,
    EnglishStep,

  },

  data() {
    return {
      editMode: false,
      loader: {},
      id: undefined,
      editorConfig: this.getEditorConfig(),
      editorKey: process.env.VUE_APP_TINY_EDITOR_KEY,
      formTitle: "",
      entityNotFoundError: false,
      submitting: false,
      formData: {},
      defaultFormData: {
        title: "",
        url: "",
        sub_title: "",
        goals: [],
        image: "",
        content: "",
        is_active: true,
        is_featured: false,
        show_in_popup: false,
        partners: [],
        news: [],
        courses: [],
        content_title: '',
        achievement: '',
        milestones_title: '',
        milestones: [],
        files: [],
        videos: [],
        focus_area_id: "",
        status: '',
        news_id: '',
      },
      wizardModel: {},
      builderData: {
        newsList: [],
        partnersList: [],
        focusAreaList : [],
        statusList : [],
        blogList : [],
        initiativeLinksType : [],
      },

    };
  },
  computed: {
    ...mapGetters({
      languageList: "global/languageList"
    })
  },
  mounted() {
    this.loader = this.$loading.show({
      container: this.$refs.initiativeForm
    });
    this.setNullFormData();
    let data = {}
    this.axios.post("initiatives/builder", data).then((response) => {
      this.builderData.newsList = response.data.news;
      this.builderData.blogList = response.data.blogs;
      this.builderData.partnersList = response.data.partners;
      this.builderData.focusAreaList = response.data.focusAreas;
      this.builderData.statusList = response.data.statusList;
      this.builderData.blogList = response.data.blogs;
      this.builderData.initiativeLinksType = response.data.initiativeLinksType;

      this.id = this.$route.params['id'];

      if (this.id !== undefined) {
        this.editMode = true;
        this.formTitle = "Edit Initiative";
        this.getInitiative();
      } else {
        this.editMode = false;
        this.formTitle = "Add Initiative";
        this.loader.hide();
      }
    }).catch((error) => {
      console.error(error);
    })

  },
  methods: {
    getInitiative() {
      let data = {
        'id': this.id,
      };
      this.axios.post("initiatives/get", data).then((response) => {
        this.formData = response.data;
        this.formData['en'].news = (this.formData['en'].news || []).map(newsItem => newsItem.id);
        this.formData['en'].partners = (this.formData['en'].partners || []).map(partner => partner.id);
        
        // Convert numeric boolean fields to actual booleans
        this.formData['en'].is_active = this.formData['en'].is_active === 1 || this.formData['en'].is_active === true;
        this.formData['en'].is_featured = this.formData['en'].is_featured === 1 || this.formData['en'].is_featured === true;
        this.formData['en'].show_in_popup = this.formData['en'].show_in_popup === 1 || this.formData['en'].show_in_popup === true;
        
        this.loader.hide();
      }).catch((error) => {
        console.error(error)
        if (error.response.status === 404) {
          this.entityNotFoundError = true;
          this.$notify({
            message: "Initiative Not Found",
            timeout: 2000,
            type: 'danger'
          });
          this.loader.hide();
        } else {
          console.error(error);
        }
      })
    },
    submit() {
      let request;
      let successMessage;
      this.submitting = true;
      
      // Map news to newsIds for API
      if (this.formData['en'].news) {
        this.formData['en'].newsIds = this.formData['en'].news;
      }
      
      if (this.editMode === true) {
        request = this.axios.put("initiatives/update/" + this.id, this.formData);
        successMessage = "Initiative Updated Successfully";
      } else {
        request = this.axios.post("initiatives/create", this.formData);
        successMessage = "Initiative Added Successfully";
      }

      request.then((response) => {
        this.$notify({
          message: successMessage,
          timeout: 1000,
          type: 'success'
        })
        this.$router.push("/initiatives/list");
      }).catch((error) => {
        if (error.response.status === 422) {
          this.$refs.formValidator.setErrors(error.response.data.errors);
          this.$refs.panelFormWizard.navigateToTab(0);
        } else {
          console.log(error.response)
        }
      }).finally(() => {
        this.submitting = false;
      })
    },
    validateStep(ref) {
      if (Array.isArray(this.$refs[ref])){
        return this.$refs[ref][0].validate();
      }else{
        return this.$refs[ref].validate();
      }
    },
    onStepValidated(validated, model) {
      this.wizardModel = {...this.wizardModel, ...model}
    },
    submitStep(data, lang, isSubmit){
      this.formData[lang] = data;
      if (isSubmit){
        this.submit();
      }
    },
    setNullFormData(){
      this.defaultFormData['en'] = {
        name: '',
        ident: '',
      };
      this.languageList.forEach(lang => {
        this.defaultFormData[lang] = {
          name: '',
          ident: '',
        }
      })
    },
  }
}
</script>
<style>
.list-items{
  border: 1px solid #ece8e8;
  margin-top: 16px;
  flex-basis: 49%;
  padding: 5px;
}
.list-partners{
  flex-basis: 100% !important;
}
</style>
